const passesThreshold = (
  percentage: number,
  comparator: string,
  threshold: number,
  protective?: number
): boolean =>
  comparator === '>'
    ? percentage / threshold > 0.75
    : percentage / threshold < 0.75;

export const ReportComparatorUtils = {
  passesThreshold,
};
